import { useEffect } from "react";
import ChildFilterErrors from "types/ChildFilterErrors";

interface useDisplayChildFilterErrorsProps{
    /** sets error message of child filters */
    setChildFilterErrorMessage: (message: string | null) => void
    /** object with errors of all child filters */
    childFilterErrors: ChildFilterErrors
    /** error message of Page Child Filters - page filters are applied to all page reports */
    childFilterPageErrorMessage?: string | null
}

const useDisplayChildFilterErrors = (props: useDisplayChildFilterErrorsProps) => {
  useEffect(() => {

    let msgs : Array<string> = []
    if (props.childFilterPageErrorMessage !== undefined && props.childFilterPageErrorMessage !== null) {
      msgs.push(props.childFilterPageErrorMessage)
    }
    
    if (Object.keys(props.childFilterErrors).length > 0) {
        {Object.entries(props.childFilterErrors).map(([_, error]) => (
            msgs.push(`No ${error.filterName} values found. Please select another ${error.parentFilterName}.`)
        ))}
        
    }
    props.setChildFilterErrorMessage(msgs.length > 0 ? msgs.join(' ') : null)

  }, [props.childFilterErrors, props.childFilterPageErrorMessage]);
  }

export default useDisplayChildFilterErrors 